import { FaEdit, FaTrash } from 'react-icons/fa'
import { RetentionPayable } from '../../data/interfaces'
import './Grids.css'

interface RetentionsPayableGridProps {
  retentionsPayable: RetentionPayable[]
  onAdd: () => void
  onEdit: (retentionPayable: RetentionPayable) => void
  onDelete: (retentionPayableId: number) => void
  lockEdit: boolean
}

const RetentionsPayableGrid = (props: RetentionsPayableGridProps) => {
  const formatCurrency = (value: number) => {
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP',
    }).format(value)
  }

  const calculateTotal = () => {
    return props.retentionsPayable.reduce((sum, retentionPayable) => sum + retentionPayable.value, 0)
  }

  return (
    <div style={{ padding: '0 1rem 1rem' }}>
      {props.retentionsPayable.length === 0 ? (
        <p style={{ textAlign: 'center', color: '#666', padding: '40px' }}>
          No retentions payable found for this job.
        </p>
      ) : (
        <>
          <div style={{ overflowX: 'auto' }}>
            <table className="grid__table" style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ backgroundColor: '#f5f5f5' }}>
                  <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #ddd' }}>Description</th>
                  <th style={{ padding: '12px', textAlign: 'right', borderBottom: '2px solid #ddd' }}>Value</th>
                  {!props.lockEdit && (
                    <th style={{ padding: '12px', textAlign: 'center', borderBottom: '2px solid #ddd', width: '120px' }}>Actions</th>
                  )}
                </tr>
              </thead>
              <tbody>
                {props.retentionsPayable.map((retentionPayable) => (
                  <tr key={retentionPayable.retentionPayableId} style={{ borderBottom: '1px solid #eee' }}>
                    <td style={{ padding: '12px' }}>{retentionPayable.description}</td>
                    <td style={{ padding: '12px', textAlign: 'right', fontWeight: 'bold' }}>
                      {formatCurrency(retentionPayable.value)}
                    </td>
                    {!props.lockEdit && (
                      <td style={{ padding: '12px', textAlign: 'center' }}>
                        <div style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
                          <FaEdit
                            style={{ cursor: 'pointer', color: '#1e2a4e', fontSize: '16px' }}
                            onClick={() => props.onEdit(retentionPayable)}
                            title="Edit Retention Payable"
                          />
                          <FaTrash
                            style={{ cursor: 'pointer', color: '#e9530d', fontSize: '16px' }}
                            onClick={() => {
                              if (window.confirm('Are you sure you want to delete this retention payable?')) {
                                props.onDelete(retentionPayable.retentionPayableId)
                              }
                            }}
                            title="Delete Retention Payable"
                          />
                        </div>
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr style={{ backgroundColor: '#f9f9f9', fontWeight: 'bold' }}>
                  <td style={{ padding: '12px', borderTop: '2px solid #ddd' }}>Total</td>
                  <td style={{ padding: '12px', textAlign: 'right', borderTop: '2px solid #ddd' }}>
                    {formatCurrency(calculateTotal())}
                  </td>
                  {!props.lockEdit && <td style={{ borderTop: '2px solid #ddd' }}></td>}
                </tr>
              </tfoot>
            </table>
          </div>
        </>
      )}
    </div>
  )
}

export default RetentionsPayableGrid
